function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M29 20L27.5306 13H7.93878L5 33H18.5",
  stroke: "black",
  strokeWidth: 3
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M24 17C24 -3 12 -3 12 17",
  stroke: "black",
  strokeWidth: 2
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M36 28.2317C36 33.3657 31.6628 38 26.5 38C20.8352 38 17 33.4167 17 28.2317C17 23.1924 21.2433 19 26.5 19C31.7567 19 36 23.1924 36 28.2317Z",
  stroke: "black",
  strokeWidth: 3
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "number",
  d: "M25.1602 27.0596H26.2471C27.1084 27.0596 27.5391 26.638 27.5391 25.7949C27.5391 25.4668 27.4365 25.2002 27.2314 24.9951C27.0264 24.7855 26.737 24.6807 26.3633 24.6807C26.0579 24.6807 25.7913 24.7695 25.5635 24.9473C25.3402 25.125 25.2285 25.346 25.2285 25.6104H22.9248C22.9248 25.0863 23.0706 24.6191 23.3623 24.209C23.654 23.7988 24.0573 23.4798 24.5723 23.252C25.0918 23.0195 25.6615 22.9033 26.2812 22.9033C27.3887 22.9033 28.2591 23.1562 28.8926 23.6621C29.526 24.168 29.8428 24.863 29.8428 25.7471C29.8428 26.1755 29.7106 26.5811 29.4463 26.9639C29.1865 27.3421 28.806 27.6497 28.3047 27.8867C28.8333 28.0781 29.248 28.3698 29.5488 28.7617C29.8496 29.1491 30 29.6299 30 30.2041C30 31.0928 29.6582 31.8037 28.9746 32.3369C28.291 32.8701 27.3932 33.1367 26.2812 33.1367C25.6296 33.1367 25.0234 33.0137 24.4629 32.7676C23.9069 32.5169 23.4854 32.1729 23.1982 31.7354C22.9111 31.2933 22.7676 30.792 22.7676 30.2314H25.085C25.085 30.5368 25.208 30.8011 25.4541 31.0244C25.7002 31.2477 26.0033 31.3594 26.3633 31.3594C26.7689 31.3594 27.0924 31.2477 27.334 31.0244C27.5755 30.7965 27.6963 30.5072 27.6963 30.1562C27.6963 29.6549 27.571 29.2995 27.3203 29.0898C27.0697 28.8802 26.7233 28.7754 26.2812 28.7754H25.1602V27.0596Z",
  fill: "black"
});

function SvgCart3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart3);
export default __webpack_public_path__ + "static/media/cart3.f20be8b9.svg";
export { ForwardRef as ReactComponent };